import { createFileRoute, getRouteApi } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { parseAgreementType, type AgreementTypeSearch } from '@/lib/agreement-type-search';
import { AGREEMENT_TYPE_VALUES, type AgreementType } from '@/features/service-agreements/types';
import { OrdersPage } from '@/features/service-agreements/orders-page';

/** The service-agreement orders. The list endpoint requires `service-agreement:read`. */
export const Route = createFileRoute('/_app/service-agreement/orders/')({
  staticData: { featureKey: 'service-agreements' },
  validateSearch: (search: Record<string, unknown>): AgreementTypeSearch<AgreementType> =>
    parseAgreementType(search, AGREEMENT_TYPE_VALUES),
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, {
      feature: 'service-agreements',
      permissions: ['service-agreement:read'],
    }),
  component: Page,
});

const routeApi = getRouteApi('/_app/service-agreement/orders/');

function Page() {
  // Keyed, so a sidebar link to another type lands on it rather than keeping the page's state.
  const { type } = routeApi.useSearch();
  return <OrdersPage key={type ?? 'default'} initialType={type} />;
}
